<ng-template #callUsersCell let-call>
  @if (call.users.length > 0) {
    <div class="user-avatar-list">
      @for (user of call.users; track user.userId) {
        <app-avatar [input]="user.firstName + ' ' + user.lastName" size="small" [matTooltip]="user.firstName + ' ' + user.lastName"></app-avatar>
      }
    </div>
  } @else {
    -
  }
</ng-template>

<div class="page-container">
  <app-toolbar [title]="'COMMON.CALLS' | translate"></app-toolbar>

  <div class="page">
    <div class="panel">
      <app-table
        [source]="source"
        [columns]="columns"
        [rowId]="rowId"
        [rowActions]="rowActions"
        [pageSize]="defaultPageSize"
        [selectable]="false"
        tableId="admin-calls"
        label="COMMON.CALLS"
        rowNoun="ADMIN.CALLS.CALL"
        rowNounPlural="ADMIN.CALLS.CALLS"
        (rowActionTriggered)="handleRowAction($event)"
      />
    </div>
  </div>
</div>
